import './styles.scss';

import React from 'react';

const getStringWidth = (string) => {
	const element = document.createElement('canvas');
    let context = element.getContext('2d');
    context.font = '20px Muli';
    return (Math.round(context.measureText(string).width) + 24) + 'px';
};

export const VideoHighlight = ({title, description, className = ''}) => {
    return (
        <div className={`video-highlight ${className}`}>
            {title ? (<div style={{maxWidth: getStringWidth(title)}}><div className="video-highlight-title branded-border">{title}</div></div>) : null}
            {description ? (<div style={{maxWidth: getStringWidth(description)}}><div className="video-highlight-description branded-border">{description}</div></div>) : null}
        </div>
    );
}

export const VideoHighlightHost = ({name, position}) => {
    return (<VideoHighlight title={name} description={position} className="video-highlight-host" />);
}

export const VideoHighlightMessage = ({from, content}) => {
    return (<VideoHighlight title={`${from} asks...`} description={content} className="video-highlight-message" />);
}

export default VideoHighlight;